import { Component, OnInit } from '@angular/core';
import { ListaPreciosService } from '../../../services/lista-precios/lista-precios.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-lista-precios',
  templateUrl: './lista-precios.component.html',
  styleUrl: './lista-precios.component.scss',
  standalone: false,
  providers: [MessageService]
})
export class ListaPreciosComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  token: any = {};
  infoUser: any = {};
  arrayListaPrecios: Array<any> = [];
  nameListOfPrices: String = "";
  new: boolean = false;
  fechaVigencia: Date = new Date();
  msg: string = "";

  constructor(private listaPrecios: ListaPreciosService,
    private toast: MessageService
  ) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
    this.get();
    // importar lista de precios
    this.load = true;

  }
  get = () => {
    this.listaPrecios.get(this.token.token).subscribe({
      next: (response) => {
        this.load = false;
        this.arrayListaPrecios = response as Array<any>;
        this.arrayListaPrecios.map((row: any) => {
          row.fechaVigencia = new Date(row.fechaVigencia);
        })
        console.log(response);
      },
      error: (error: HttpErrorResponse) => { if (error.status == 401 || error.status == 0) { throw Error("closeOfSession"); } this.load = false; }
    })
  }

  updateLista = (row: any) => {
    const data = {
      "idListaPrecios": row.idListaPrecios,
      "nombreListaPrecios": row.nombreListaPrecios,
      "fechaVigencia": row.fechaVigencia,
      "activo": row.activo
    }
    this.listaPrecios.set(this.token.token, data).subscribe({
      next: (response) => {
        row.msg = '<div class="p-message p-message-success p-3">Procesamiento exítoso</div>';
        console.log(response);
      },
      error: (error: HttpErrorResponse) => {
        row.msg = '<div class="p-message p-message-danger p-3">Se ha presentado un error</div>';
        if (error.status == 401 || error.status == 0) { throw Error("closeOfSession"); }
      }
    })
  }

  createLista = () => {
    this.msg = '';
    if (this.nameListOfPrices != "") {
      const data = {
        "idListaPrecios": 0,
        "nombreListaPrecios": this.nameListOfPrices,
        "fechaVigencia": this.fechaVigencia,
        "activo": true
      }
      this.listaPrecios.set(this.token.token, data).subscribe({
        next: () => {
          this.msg = '<div class="p-message p-message-success p-3">Procesamiento exítoso</div>';
          this.new = false;
          this.nameListOfPrices = "";
          this.get();
          this.msg = '';
        },
        error: (error: HttpErrorResponse) => {
          this.msg = '<div class="p-message p-message-danger p-3">Se ha presentado un error</div>';
          if (error.status == 401 || error.status == 0) { throw Error("closeOfSession"); }
        }
      })
    } else
      this.msg = '<div class="p-message p-message-warn p-3">Favor relacione el nombre de la lista de precios</div>';

  }


  setListaDefault = (idListaPrecios: number) => {
    // limpiar todos los check con referente a lista por defecto
    this.arrayListaPrecios.map((row: any) => {
      if (row.idListaPrecios == idListaPrecios)
        row.default = true
      else
        row.default = false
    })
    // proceder con la actualización
    this.listaPrecios.setListaDefault(this.token.token, idListaPrecios).subscribe({
      next: (response) => {
        this.toast.add({ key: 'message', severity: 'success', detail: response.toString() });
      },
      error: (error: HttpErrorResponse) => {
        this.toast.add({ key: 'message', severity: 'danger', detail: error.message });
        if (error.status == 401 || error.status == 0) { throw Error("closeOfSession"); }
      }
    })
  }


}
